import { render, staticRenderFns } from "./ProfileProjectsView.vue?vue&type=template&id=80d6cfc6&scoped=true"
import script from "./ProfileProjectsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileProjectsView.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileProjectsView.vue?vue&type=style&index=0&id=80d6cfc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d6cfc6",
  null
  
)

export default component.exports